import { useNavigate } from "react-router-dom";
import { Flex, 
    Image, 
    Text, 
    Drawer,
    DrawerOverlay,
    DrawerBody,
    DrawerContent,
    Box,
} from "@chakra-ui/react";
import { 
    AiOutlineHome, 
    AiOutlineUser,  
} from "react-icons/ai";
import { HamburgerIcon } from "@chakra-ui/icons";
import { SiGooglemaps } from "react-icons/si";
import { BsTrophyFill } from "react-icons/bs";

import beneficiosIcon from "assets/svg/beneficios.svg";
import resgateIcon from "assets/svg/resgate.svg";
import higieneESaudeIcon from "assets/svg/higiene-e-saude.svg";
import promocoesIcon from "assets/svg/promocoes.svg";
import { useContext, useEffect, useState } from "react";
import api from "services/api";
import { useAuth } from "hooks/useAuth";
import { Context as ContextStore } from '../../../contexts/store';
import { Context as ContextCart } from '../../../contexts/cart';
import { Context as ContextActivated } from '../../../contexts/activated';

interface SubCategoryProps {
    categoriaId?: number;
    id?: number;
    descricao: string;
    uri: string;
}

interface CategoryProps {
    id: number;
    descricao: string;
    uri: string;
    subCategoria: SubCategoryProps[];
}

interface SubHeaderProps {
    isShowMenuList: boolean;
    handleShowMenuList: (categoryId: number, descricao?: any) => void;
    setIsShowMenuList: (value: boolean) => void;
    categoryIdRef: any;
    categories: CategoryProps[];
}


export const SubHeader1 = ({
    isShowMenuList,
    handleShowMenuList,
    setIsShowMenuList,
    categoryIdRef,
    categories,
}: SubHeaderProps) => {

    const navigate = useNavigate();
    const [dateExpire, setDateExpire] = useState<any>('');
    const [stateStore, dispatchStore] = useContext<any>(ContextStore);
    const [stateCart, dispatchCart] = useContext<any>(ContextCart);
    const [stateActivated, dispatchActivated] = useContext<any>(ContextActivated);
    const [quantityDiscount, setQuantityDiscount] = useState<any>(0);
    const [subMenuIsOpen, setSubMenuIsOpen] = useState<boolean>(false);
    const { user, signOut } = useAuth();
    
    const SubMenu = (props) => {

        const isOpen = props.isOpen;
        const setIsOpen = props.setIsOpen;

        const onClose = () => {
            setIsOpen(false);
        }

        return (
        <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
            <DrawerOverlay />
            <DrawerContent>
                <DrawerBody width="100%" minWidth="319px" overflowX="hidden" backgroundColor="#0A5888" marginTop={8}>
                    <Flex className="submenu" style={{backgroundColor: "#0A5888"}}>
                        <Flex className="menu-item"
                            onClick={() => {
                                setSubMenuIsOpen(false);
                                navigate("/meus-dados");
                            }}>
                            <AiOutlineUser fontSize={42} />
                            <Text className="menu-text">
                                Meu Cadastro
                            </Text>
                        </Flex>
                        <Flex className="menu-item"
                            onClick={() => {
                                setSubMenuIsOpen(false);
                                navigate("/extrato-de-pontos");
                            }}>
                            <Image className="menu-image" src={beneficiosIcon} />
                            <Text className="menu-text">
                                Extrato de Pontos
                            </Text>
                        </Flex>
                        <Flex className="menu-item"
                            onClick={() => {
                                setSubMenuIsOpen(false);
                                navigate("/extrato-resgate");
                            }}>
                            <Image className="menu-image" src={resgateIcon} />
                            <Text className="menu-text">
                                Meus Resgates
                            </Text>
                        </Flex>
                        {user?.extendedData?.atendente === "true" &&
                        <Flex className="menu-item"
                            onClick={() => {
                                setSubMenuIsOpen(false);
                                navigate("/ranking-atendimento");
                            }}>
                            <BsTrophyFill fontSize={42} color="#AFA" />
                            <Text className="menu-text">
                                Ranking Vitaderm
                            </Text>
                        </Flex>
                        }
                    </Flex>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
        )
    }

    useEffect(() => {
        verifyHaveCartActive()
    }, [])

    useEffect(() => {
        setQuantityDiscount(stateActivated.quantidade)
    }, [stateActivated])

    const verifyHaveCartActive = async () => {
        let { data } = await api.get("/motorDePontos/consultarCarrinhoAtivo");
        if (data.length > 0) {
            dispatchCart({ type: "CHANGE_SHOW_CART", isShow: false })
            dispatchActivated({ type: "UPDATE_QUANT_ACTIVATED", quantidade: data.length })
            setQuantityDiscount(data.length)
        } else {
            dispatchActivated({ type: "UPDATE_QUANT_ACTIVATED", quantidade: 0 })
        }
    }

    function getDescriptionCategory(id: number) {
        if (!id) return;
        const category = categories.find((category) => category.id === id);
        if (!category) return;
        return category?.descricao;
    }

    function getCategory(id: number) {
        if (!id) return;
        const category = categories.find((category) => category.id === id);
        if (!category) return;
        return category;
    }

    return (
        <>  
        <Flex className="container-menu">
            <Flex className="menu">
                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/home");
                    }}>
                    <AiOutlineHome fontSize={40} />
                    <Text className="menu-text">
                        Home
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/categoria");
                    }}>
                    <Image className="menu-image" src={higieneESaudeIcon} />
                    <Text className="menu-text">
                        Produtos
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => navigate("/beneficios")}>
                    <Image className="menu-image" src={promocoesIcon} />
                    <Text className="menu-text">
                        Benefícios
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => navigate("/por-perto")}>
                    <SiGooglemaps fontSize={42} />
                    <Text className="menu-text">
                        Lojas
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => {
                        navigate("/resgate-pix");
                    }}>
                    <Image className="menu-image" src={resgateIcon} />
                    <Text className="menu-text">
                        Resgate
                    </Text>
                </Flex>

                <Flex className="menu-item"
                    onClick={() => {
                        setSubMenuIsOpen(true)
                    }}>
                    <AiOutlineUser fontSize={42} />
                    <Text className="menu-text">
                        Minha conta
                    </Text>
                </Flex>

            </Flex>
        </Flex>
        <SubMenu isOpen={subMenuIsOpen} setIsOpen={setSubMenuIsOpen} />
        </>
    );
};
